<template>
  <b-card>
    <div class="d-flex align-items-center justify-content-between">
      <div class="d-flex align-items-center">
        <div>
          <b-avatar
            :variant="dataItem.color"
            size="50"
          >
            <FeatherIcon
              :icon="dataItem.icon"
              size="20"
            />
          </b-avatar>
        </div>
        <div class="ml-1">
          <div class="font-weight-bold">
            {{ dataItem.label }}
          </div>
          <div class="font-weight-bolder font-medium-4">
            {{ dataItem.items | toNumber }}
          </div>
        </div>
        <div
          v-if="dataItem.docs !== undefined"
          class="ml-2 border-left pl-2"
        >
          <div class="font-weight-bold">
            Dokümanlar
          </div>
          <div class="font-weight-bolder font-medium-4">
            {{ dataItem.docs | toNumber }}
          </div>
        </div>
      </div>
      <div>
        <b-button
          pill
          variant="flat-primary"
          class="btn-icon"
          :to="dataItem.url"
        >
          <FeatherIcon icon="EyeIcon" />
        </b-button>
      </div>
    </div>
  </b-card>
</template>
<script>
import { BAvatar, BCard, BButton } from 'bootstrap-vue'

export default {
  name: 'CounterItem',
  components: {
    BAvatar,
    BCard,
    BButton,
  },
  props: {
    dataItem: {
      type: Object,
      default: null,
    },
  },
}
</script>
